import get from 'lodash/get';
import find from 'lodash/find';
import filter from 'lodash/filter';
import head from 'lodash/head';

import defaultLocaleData from 'react-intl/locale-data/en';
import defaultMessages from './translations/split/en_us.json';
import supportedLocales from './locales';
import localeImports from './localeImports';
import store from '../../sdk/store';

const DEFAULT_LOCALE = 'en_us';

export const getLocale = () => {
  const forcedLang = store.get('lang');
  const lang = forcedLang || get(navigator, ['languages', 0], navigator.browserLanguage || DEFAULT_LOCALE);
  return lang;
};

export const getLocaleFormatted = () => {
  const locale = getLocale();

  return locale && locale.toLowerCase().replace('-', '_');
};

export const locale = getLocaleFormatted();

export const getAllowedLocales = () =>
  filter(supportedLocales, l => !l.hidden || process.env.NODE_ENV === 'development');

export const getLocaleData = () => {
  const currentLocale = getLocaleFormatted();

  const localeDataFetch = get(localeImports, [currentLocale, 'getLocaleData']);

  if (!localeDataFetch) {
    return Promise.resolve({ default: defaultLocaleData });
  }

  return localeDataFetch().catch(() => {
    return Promise.resolve({ default: defaultLocaleData });
  });
};

export const getMessages = () => {
  const currentLocale = getLocaleFormatted();
  const messagesFetch = get(localeImports, [currentLocale, 'getMessages']);

  if (!messagesFetch) {
    return Promise.resolve({ default: defaultMessages });
  }

  return messagesFetch().catch(() => {
    return Promise.resolve({ default: defaultMessages });
  });
};

export const getCurrentAllowedLocale = () => {
  const currentLocale = getLocaleFormatted();
  const allowedLocales = getAllowedLocales();
  const allowedLocale = find(allowedLocales, localeData => localeData.locale === currentLocale);
  const defaultAllowedLocale = find(allowedLocales, localeData => localeData.locale === 'en_us');

  return allowedLocale || defaultAllowedLocale;
};

export const formatLocaleData = localeData => {
  const allowedLocale = getCurrentAllowedLocale();
  const defaultPluralRuleFunction = () => 'other';

  const parentLocale = allowedLocale.parentLocale;
  const parentLocaleData = head(localeData);

  const formattedLocaleData = [...localeData, ...defaultLocaleData];

  if (parentLocale) {
    formattedLocaleData.unshift({
      locale: allowedLocale.locale,
      parentLocale,
      pluralRuleFunction: parentLocaleData.pluralRuleFunction || defaultPluralRuleFunction,
      fields: parentLocaleData.fields,
    });
  }

  return formattedLocaleData.reduce((acc, val) => {
    const newAcc = acc;
    newAcc[val.locale] = val;
    return newAcc;
  }, {});
};
